export const SET_ASSETTYPES = "app/ssList/SET_ASSETTYPES"
export const SET_ASSET_CLASSES = "app/ssList/SET_ASSET_CLASSES"
export const SET_MANUFACTURES = "app/ssList/SET_MANUFACTURES"
